import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { FaQuoteLeft, FaUserPlus } from "react-icons/fa6";

const AboutUs = () => {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Left Aspect Video Framework Container */}
        <div className="lg:col-span-6 w-full">
          <div className="relative overflow-hidden rounded-2xl bg-stone-900 border border-stone-100 shadow-xl aspect-video group">
            <ReactPlayer
              url="https://www.youtube.com/watch?v=A1qlpNkoZHM"
              className="absolute top-0 left-0"
              width="100%"
              height="100%"
              controls
            />
          </div>
        </div>

        {/* Right Aspect Dynamic Copy Segment */}
        <div className="lg:col-span-6 space-y-6">
          <Fade direction="up" triggerOnce>
            <span className="text-xs font-bold tracking-widest uppercase text-emerald-800 block">
              Mission Statement
            </span>
            <h2 className="text-4xl font-extrabold text-green-950 tracking-tight">
              Our Purpose
            </h2>
          </Fade>

          {/* Hadith Typography Block */}
          <div className="relative bg-white border-l-4 border-emerald-700 rounded-r-2xl p-6 shadow-sm">
            <FaQuoteLeft className="absolute top-4 right-4 text-stone-100 w-10 h-10 -z-0 pointer-events-none" />
            <p className="text-base font-medium text-gray-700 leading-relaxed font-serif relative z-10">
              “A charity is due for every joint in each person on every day the
              sun comes up: to act justly between two people is a charity; to
              help a man with his mount, lifting him onto it or hoisting up his
              belongings onto it, is a charity; a good word is a charity, and
              removing a harmful thing from the road is a charity.”
            </p>
            <span className="block text-xs font-bold uppercase tracking-wider text-emerald-800 mt-3 text-right">
              — Sahih Al-Bukhari, Muslim
            </span>
          </div>

          <Slide direction="up" triggerOnce>
            <div className="pt-2">
              <Link
                to="/membership"
                className="inline-flex items-center gap-2 px-6 py-3 bg-green-950 text-white font-semibold rounded-full hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-0.5 shadow-md hover:shadow-lg text-sm"
              >
                <FaUserPlus className="w-4 h-4" />
                <span>Join Our Membership</span>
              </Link>
            </div>
          </Slide>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
